"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
require("core-js/modules/es.array.concat.js");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/universe-ui/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';

var ImageOptimize = function ImageOptimize(props) {
  var className = props.className,
    style = props.style,
    content = props.content,
    _props$tips = props.tips,
    tips = _props$tips === void 0 ? ['优化前', '优化后'] : _props$tips,
    imgList = props.imgList,
    getImgStatus = props.getImgStatus,
    getImgState = props.getImgState,
    getIsMoblie = props.getIsMoblie,
    _props$defaultRange = props.defaultRange,
    defaultRange = _props$defaultRange === void 0 ? 50 : _props$defaultRange,
    getRange = props.getRange;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('image-optimize');
  var classes = (0, _classnames.default)(prefixCls, className);
  var _useState = (0, _react.useState)(defaultRange),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    range = _useState2[0],
    setRange = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    imgState = _useState4[0],
    setImgState = _useState4[1];
  var _useState5 = (0, _react.useState)('50%'),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    bgPosition = _useState6[0],
    setBgPosition = _useState6[1];
  var imgRef = (0, _react.useRef)(null);
  function getImageSize() {
    return _getImageSize.apply(this, arguments);
  }
  function _getImageSize() {
    _getImageSize = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var img, width, height, oImgState;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            img = imgRef.current;
            if (img) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            width = img.width === img.naturalWidth ? img.clientWidth : img.width;
            height = img.height === img.naturalHeight ? img.clientHeight : img.height;
            oImgState = {
              imgWidth: width,
              imgHeight: height,
              imgLeft: img.offsetLeft,
              transform: {
                scaleX: width / img.naturalWidth,
                scaleY: height / img.naturalHeight,
                offsetY: img.offsetTop,
                // + img.paddingTop,
                offsetX: img.offsetLeft // + img.style.paddingLeft
              }
            };
            _context.next = 10;
            return setImgState(oImgState);
          case 10:
            _context.next = 12;
            return setBgPosition("".concat(range / 100 * (oImgState.imgLeft * 2 + oImgState.imgWidth) - oImgState.imgLeft, "px"));
          case 12:
            if (getImgState) {
              getImgState(oImgState);
            }
            if (getImgStatus) {
              getImgStatus(false);
            }
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getImageSize.apply(this, arguments);
  }
  var handleChangeRange = function handleChangeRange(e) {
    var oRange = e.target.value;
    if (getRange) {
      getRange(oRange);
    }
    setRange(oRange);
    setBgPosition("".concat(oRange / 100 * (imgState.imgLeft * 2 + imgState.imgWidth) - imgState.imgLeft, "px"));
  };
  (0, _react.useEffect)(function () {
    setRange(defaultRange);
  }, [defaultRange]);
  (0, _react.useEffect)(function () {
    if (window.outerWidth <= 768) {
      if (getIsMoblie) {
        getIsMoblie(true);
      }
    }
  }, [getIsMoblie]);
  function handleImgError() {
    return _handleImgError.apply(this, arguments);
  }
  function _handleImgError() {
    _handleImgError = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (getImgStatus) {
              getImgStatus(false);
            }
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleImgError.apply(this, arguments);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ai-demo-beerslider-media"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "beer-slider",
    className: "beer-slider beer-ready",
    style: {
      width: "".concat(imgState === null || imgState === void 0 ? void 0 : imgState.imgWidth, "px")
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "png-bg"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "beer-after-title",
    style: {
      left: "".concat(range, "%")
    }
  }, tips[1]), /*#__PURE__*/_react.default.createElement("img", {
    src: imgList[1],
    alt: "",
    ref: imgRef,
    onLoad: getImageSize,
    onError: handleImgError,
    style: {
      maxWidth: '100%',
      maxHeight: '100%'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "beer-reveal",
    "data-before-label": tips[0],
    style: {
      width: '100%'
    }
  }, imgState && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: imgState.imgWidth,
      height: imgState.imgHeight,
      margin: '0 auto',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: imgState.imgWidth * range / 100,
      height: imgState.imgHeight,
      backgroundImage: "Url(".concat(imgList[0], ")"),
      backgroundSize: "".concat(imgState.imgWidth, "px ").concat(imgState.imgHeight, "px")
    }
  }))), /*#__PURE__*/_react.default.createElement("input", {
    className: "beer-range",
    type: "range",
    "data-aria-label": "Percent of revealed content",
    "data-aria-valuemin": "0",
    "data-aria-valuemax": "100",
    step: "1",
    "aria-valuenow": range,
    value: range,
    min: "0",
    max: "100",
    onChange: function onChange(e) {
      return handleChangeRange(e);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "beer-handle",
    style: {
      left: "".concat(range, "%")
    }
  }))));
};
ImageOptimize.defaultProps = {
  content: '测试内容'
};
var _default = exports.default = ImageOptimize;